import React from "react";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemSearchResult from "../../../models/ItemSearchResult";
import DataService from "../../../services/data.service";
import { BusinessPartnerPopupProps } from "../../../types/PopupProps";
import ItemSearchMiniView from "../../Search/ItemMini";

interface ItemBusinessPartnerModel {
    itemId: number
    itemRevisionId?: number
    businessPartnerId: number
}

const AddItemPopup: React.FC<BusinessPartnerPopupProps> = ({ show, onHide, businessPartnerId }) => {
    const { handleResult, handleException } = useNotifications();

    function handleItemclicked(itemRevision: ItemSearchResult) {
        const itemBusinessPartner: ItemBusinessPartnerModel = {
            businessPartnerId,
            itemId: itemRevision.itemId,
            itemRevisionId: itemRevision.itemRevisionId
        }

        DataService
            .create<ItemBusinessPartnerModel>(`api/v1/ItemBusinessPartners`, itemBusinessPartner)
            .then(response => {
                handleResult(response);
                if (response.isSuccesful === true) {
                    if (onHide)
                        onHide();
                }
            })
            .catch(e => handleException(e));
    }

    return (
        <Popup show={show} onHide={onHide} size={'xxl'} title={'Add Item'} >
            <Popup.Body>
                <ItemSearchMiniView handleItemClicked={handleItemclicked} forBom={false}  />
            </Popup.Body>
        </Popup>
    );
}
export default AddItemPopup;